import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';


Chart.register(ChartDataLabels);

const BarGraph = ({ data, options }) => (
  <Bar data={data} options={options} plugins={[ChartDataLabels]} />
);

export default BarGraph;
